import type { UsersPageSearchSupplierFragmentFragment } from '../../../../generated';

export interface SupplierSelectOption {
  value: string;
  label: string;
}

export const getSelectOptionFromSupplier = (
  supplier: UsersPageSearchSupplierFragmentFragment
): SupplierSelectOption => ({
  value: supplier.id,
  label: supplier.name, // Simplified since referenceId is not available in this fragment
});

export const formatSupplierLabel = (
  name: string,
  referenceId: string
): string => {
  return `${name}-${referenceId}`;
};
